import styled from "styled-components";
import {GameJackpotBarToggleSliderDefaultBox} from "./game-jackpot-bar-toggle-slider.default.box";

export const GameJackpotBarToggleSliderMrgeenBox = styled(GameJackpotBarToggleSliderDefaultBox)<{checked: boolean}>`
  background-color: ${props => (props.checked ? '#DDDCAA80' : '#FFFFFF66')};

  &:before {
         ${props => props.checked ?
            'background: linear-gradient(270deg, #F8F195 0.11%, #F8F3CA 50.11%, #F8F195 100.11%)' :
            'background-color: #FFFFFF'
        };
  };  
`;